import React from 'react';
import { Link } from 'react-router-dom';
import { products } from '../data/products';

const Products = () => {

  return (
    <div className="products-page">
      <div className="products-hero">
        <div className="container">
          <h1>Our Mushroom Extracts</h1>
          <p>Concentrated medicinal mushroom powders from the forests of the Kootenays</p>
        </div>
      </div>

      <main className="main-content">
        <div className="container">
          <div className="products-grid">
            {products.map((product) => (
              <Link key={product.id} to={`/products/${product.id}`} className="simple-product-card">
                <div className="simple-product-image">
                  <img src={product.image} alt={product.name} />
                </div>
                <div className="simple-product-info">
                  <h3>{product.name}</h3>
                  <p className="simple-product-description">{product.shortDescription}</p>
                  <p className="simple-product-price">{product.price}</p>
                </div>
              </Link>
            ))}
          </div>

          <section className="product-info">
            <h2>Why MindLever Mushroom Extracts?</h2>
            <div className="info-grid">
              <div className="info-card">
                <h4>Concentrated Extract Powders</h4>
                <p>We use only mushroom extract powders, not ground fruiting bodies or mycelium on grain. Maximum bioavailability of beneficial compounds like beta-glucans and polysaccharides.</p>
              </div>
              <div className="info-card">
                <h4>Kootenay Sourced</h4>
                <p>Sustainably wildcrafted and cultivated from the pristine forests of British Columbia. Each mushroom species is carefully selected for optimal potency.</p>
              </div>
              <div className="info-card">
                <h4>Pure Formulations</h4>
                <p>Nothing but mushroom extracts and minimal necessary fillers. Full transparency on every label so you know exactly what medicinal mushrooms you're getting.</p>
              </div>
              <div className="info-card">
                <h4>Traditional & Scientific</h4>
                <p>Our formulations honor centuries of traditional mushroom medicine while backed by modern mycological research and clinical studies.</p>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Products;
